
import { ListDataSource } from "@/data/List/ListDataSource";
import { ComponentLinkDataSource } from "@/data/List/ComponentLinkDataSource";
import { Vue, Component, Watch } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";

@Component({
  mixins: [editor],
  components: { ObjectDataTable },
})
export default class ProductLinkInlineEditor extends Vue {
  dataSource!: ObjectDataSource;
  searchTimer: any = null;
  dialog: boolean = false;
  searchText: string = "";
  filterText: string = "";
  loaded: boolean = false;
  icons: any = {
    plus: mdiPlus,
    minus: mdiMinus,
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
  };

  headers: any[] = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Подпись",
      value: "caption",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  commodityDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 100 },
    className: "commodity",
  });

  linkedCommodityDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 100 },
    className: "commodity",
  });

  componentLinkDataSource: ComponentLinkDataSource =
    new ComponentLinkDataSource();
  $message: any;

  updateCommodities() {
    let sourceItems = [...this.commodityDataSource.items];

    for (const commodity of sourceItems) {
      const cb = (c: any) => c.id == commodity.id;
      const exists = this.dataSource.model?.commodities.some(cb);
      if (exists) {
        const index = this.commodityDataSource.items.findIndex(cb);
        this.commodityDataSource.items.splice(index, 1);
        // this.linkedCommodityDataSource.items.push(commodity);
      }
    }
    this.linkedCommodityDataSource.items = this.dataSource.model?.commodities;
  }

  filterLinkedCommodity() {
    this.updateCommodities();
    if (!this.filterText) return;
    const re = new RegExp(this.filterText, "gi");
    this.linkedCommodityDataSource.items =
      this.linkedCommodityDataSource.items.filter((c: any) =>
        c.caption.match(re),
      );
  }

  async created() {
    await this.commodityDataSource.get();
    this.linkedCommodityDataSource.metadata = this.commodityDataSource.metadata;
    this.linkedCommodityDataSource.total =
      this.dataSource.model?.commodities?.length;
    this.updateCommodities();
    this.loaded = true;
  }

  async add(item: any) {
    await this.componentLinkDataSource.add({
      componentId: item.id,
      componentClassId: item.classId,
      linkedComponentId: this.dataSource.id,
      linkedComponentClassId: this.dataSource.model?.classId,
    });

    await this.dataSource.get();
    this.updateCommodities();
    this.linkedCommodityDataSource.total =
      this.linkedCommodityDataSource.items.length;
    this.$message("Успешно добавлено");
  }

  async remove(item: any) {
    await this.componentLinkDataSource.remove({
      componentId: item.id,
      componentClassId: item.classId,
      linkedComponentId: this.dataSource.id,
      linkedComponentClassId: this.dataSource.model?.classId,
    });
    const index = this.linkedCommodityDataSource.items.findIndex(
      (c: any) => c.id === item.id,
    );
    if (index === -1) throw new Error("не найден");
    this.linkedCommodityDataSource.items.splice(index, 1);
    this.commodityDataSource.items.push(item);
    this.linkedCommodityDataSource.total =
      this.linkedCommodityDataSource.items.length;

    this.$message("Успешно удалено");
  }

  @Watch("searchText")
  debounceSearch(value: string) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(async () => {
      this.commodityDataSource.config.filter = JSON.stringify([
        {
          fieldName: "searchText",
          fieldValue: value,
        },
      ]);
      await this.commodityDataSource.get();
      this.updateCommodities();
    }, 1000);
  }
}
